import type { MutationKey, QueryKey } from '@tanstack/react-query'

// based on https://github.com/TanStack/query/blob/edd1bd08e0ef9e55cd2d9339a63843539292fed7/packages/query-core/src/utils.ts#L215
export function hashQueryKeyWithoutTel(queryKey: QueryKey | MutationKey): string {
  return JSON.stringify(queryKey, (_, val) =>
    isPlainObject(val)
      ? Object.keys(val)
          .sort()
          .reduce((result, key) => {
            if (key === 'tel') return result

            result[key] = val[key]
            return result
          // biome-ignore lint/suspicious/noExplicitAny: <explanation>
          }, {} as any)
      : val,
  )
}


function isPlainObject(val: unknown): val is Record<string, unknown> {
  return typeof val === 'object' && val !== null && !Array.isArray(val)
}
